module.exports = __webpack_public_path__ + "3667a84b374fcd58d5cf483c0db3ba28.svg";